import { render, staticRenderFns } from "./school-big-data.vue?vue&type=template&id=5a0a86ed&scoped=true"
import script from "./school-big-data.vue?vue&type=script&lang=js"
export * from "./school-big-data.vue?vue&type=script&lang=js"
import style0 from "./school-big-data.vue?vue&type=style&index=0&id=5a0a86ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0a86ed",
  null
  
)

export default component.exports